(() => {
  const slugify = (value) => value.toLowerCase().trim().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  const icons = {
    purchase: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M8 9h4l4 23h21l4-15H14M20 40a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" fill="none" stroke="currentColor" stroke-width="2.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    shipping: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M5 13h23v20H5zM28 20h7l7 8v5H28zM12 37a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm24 0a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" fill="none" stroke="currentColor" stroke-width="2.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    payment: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M6 12h36v24H6zM6 19h36M12 29h10" fill="none" stroke="currentColor" stroke-width="2.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    support: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 16a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0-10v5m0 26v5M6 24h5m26 0h5M11.3 11.3l3.5 3.5m18.4 18.4 3.5 3.5m0-25.4-3.5 3.5M14.8 33.2l-3.5 3.5" fill="none" stroke="currentColor" stroke-width="2.7" stroke-linecap="round"/></svg>',
    quality: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 5 38 11v10c0 10-5.8 17.2-14 22-8.2-4.8-14-12-14-22V11zM17 23l5 5 9-11" fill="none" stroke="currentColor" stroke-width="2.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    star: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="m24 5 5.7 11.6 12.8 1.9-9.3 9 2.2 12.7L24 34.2l-11.4 6 2.2-12.7-9.3-9 12.8-1.9z" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linejoin="round"/></svg>'
  };

  const iconFor = (title) => {
    const value = title.toLowerCase();
    if (value.includes('payment')) return icons.payment;
    if (value.includes('install') || value.includes('support')) return icons.support;
    if (value.includes('quality')) return icons.quality;
    if (value.includes('after') || value.includes('order') || value.includes('shipping')) return icons.shipping;
    if (value.includes('why')) return icons.star;
    return icons.purchase;
  };

  const displayTitle = (id, title) => ({
    'after-purchase': 'Orders & Shipping',
    'installation-and-support': 'Installation & Support',
    'why-choose-euronavigate': 'Why Choose Euronavigate?'
  }[id] || title);

  const leadingStrong = (node) => {
    if (node.tagName !== 'P') return null;
    for (const child of node.childNodes) {
      if (child.nodeType === Node.TEXT_NODE && !child.textContent.trim()) continue;
      if (child.nodeType === Node.ELEMENT_NODE && child.tagName === 'BR') continue;
      return child.nodeType === Node.ELEMENT_NODE && child.tagName === 'STRONG' ? child : null;
    }
    return null;
  };

  const questionText = (node) => {
    const strong = leadingStrong(node);
    return strong ? strong.textContent.trim() : '';
  };

  const sameParagraphAnswer = (node) => {
    const strong = leadingStrong(node);
    if (!strong) return null;
    const clone = node.cloneNode(true);
    const firstStrong = clone.querySelector(':scope > strong');
    firstStrong?.remove();
    while (clone.firstChild && (clone.firstChild.nodeName === 'BR' || (clone.firstChild.nodeType === 3 && !clone.firstChild.textContent.trim()))) {
      clone.firstChild.remove();
    }
    return clone.textContent.trim() ? clone : null;
  };

  document.querySelectorAll('[data-faq-canonical]').forEach((root) => {
    const isAz = (document.documentElement.lang || '').toLowerCase().startsWith('az');
    const isFr = (document.documentElement.lang || '').toLowerCase().startsWith('fr');
    const sourceWrap = root.querySelector('[data-faq-source]');
    const source = sourceWrap?.querySelector('.help-center-rich-text');
    const target = root.querySelector('[data-faq-accordion]');
    const nav = root.querySelector('[data-faq-nav]');
    const panel = root.querySelector('[data-faq-panel]');
    const panelTitle = root.querySelector('[data-faq-panel-title]');
    const count = root.querySelector('[data-faq-count]');
    const searchForm = root.querySelector('[data-faq-search-form]');
    const searchInput = root.querySelector('[data-faq-search-input]');
    if (!source || !target || !nav || !panel || !panelTitle || !count) return;

    const sections = [];
    let current = null;
    [...source.children].forEach((node) => {
      if (node.tagName === 'H2') {
        const title = node.textContent.trim();
        current = { title, id: slugify(title), nodes: [] };
        sections.push(current);
      } else if (current && node.tagName !== 'HR') {
        current.nodes.push(node.cloneNode(true));
      }
    });
    if (!sections.length) return;

    sections.forEach((section) => {
      const sectionEl = document.createElement('section');
      sectionEl.className = 'faq-canonical__category-section';
      sectionEl.id = 'faq-' + section.id;

      const heading = document.createElement('h3');
      heading.className = 'faq-canonical__category-title';
      heading.innerHTML = '<span class="faq-canonical__section-icon" aria-hidden="true">' + iconFor(section.title) + '</span><span></span>';
      heading.lastElementChild.textContent = displayTitle(section.id, section.title);
      sectionEl.appendChild(heading);

      section.details = [];
      for (let i = 0; i < section.nodes.length; i += 1) {
        const node = section.nodes[i];
        const question = questionText(node);
        if (!question) continue;

        const details = document.createElement('details');
        details.className = 'faq-canonical__details';

        const summary = document.createElement('summary');
        summary.textContent = question;
        details.appendChild(summary);

        const answer = document.createElement('div');
        answer.className = 'faq-canonical__answer';
        const inlineAnswer = sameParagraphAnswer(node);
        if (inlineAnswer) answer.appendChild(inlineAnswer);

        let j = i + 1;
        while (j < section.nodes.length && !questionText(section.nodes[j])) {
          answer.appendChild(section.nodes[j].cloneNode(true));
          j += 1;
        }
        i = j - 1;
        details.appendChild(answer);
        sectionEl.appendChild(details);
        section.details.push(details);
      }

      if (!section.details.length) {
        const note = document.createElement('div');
        note.className = 'faq-canonical__note';
        section.nodes.forEach((node) => note.appendChild(node.cloneNode(true)));
        sectionEl.appendChild(note);
        section.note = note;
      }

      section.element = sectionEl;
      section.searchText = sectionEl.textContent.toLowerCase();
    });


    const beforePurchase = sections.find(section => section.id === 'before-purchase');
    const ordersShipping = sections.find(section => section.id === 'after-purchase');
    if (beforePurchase && ordersShipping) {
      const shippingIndex = beforePurchase.details.findIndex((details) =>
        details.querySelector('summary')?.textContent.trim().toLowerCase().includes('express shipping')
      );
      if (shippingIndex >= 0) {
        const shippingDetails = beforePurchase.details.splice(shippingIndex, 1)[0];
        shippingDetails.remove();
        ordersShipping.details.unshift(shippingDetails);
        const ordersHeading = ordersShipping.element.querySelector('.faq-canonical__category-title');
        ordersHeading?.insertAdjacentElement('afterend', shippingDetails);
        beforePurchase.searchText = beforePurchase.element.textContent.toLowerCase();
        ordersShipping.searchText = ordersShipping.element.textContent.toLowerCase();
      }
    }


    // Section-end policy cards replace inline duplicates and the old Full Policies row.
    const localizedRoot = window.location.pathname.match(/^\/([^/]+)\/pages\/faq\/?$/);
    const marketPrefix = localizedRoot ? '/' + localizedRoot[1] : '';
    const policyCatalog = {
      'shipping-policy': ['Shipping Policy', 'Çatdırılma siyasəti'],
      'refund-policy': ['Refund Policy', 'Qaytarma və geri ödəniş siyasəti'],
      'privacy-policy': ['Privacy Policy', 'Məxfilik siyasəti'],
      'terms-of-service': ['Terms of Service', 'İstifadə şərtləri'],
      'legal-notice': ['Legal Notice', 'Hüquqi bildiriş'],
      'contact-information': ['Contact Information', 'Əlaqə məlumatları']
    };
    const frenchPolicyLabels = {
      "shipping-policy": "Politique de livraison",
      "refund-policy": "Politique de remboursement",
      "privacy-policy": "Politique de confidentialité",
      "terms-of-service": "Conditions d’utilisation",
      "legal-notice": "Mentions légales",
      "contact-information": "Coordonnées"
};
    const policiesBySection = [
      ['terms-of-service', 'legal-notice'],
      ['shipping-policy'],
      ['refund-policy'],
      [],
      ['privacy-policy'],
      ['contact-information']
    ];
    sections.forEach((section, index) => {
      section.details = section.details.filter((details) => {
        const label = (details.querySelector('summary')?.textContent || '').trim().replace(/:$/, '').toLowerCase();
        if (label === 'full policies' || label === 'bütün siyasətlər') {
          details.remove();
          return false;
        }
        return true;
      });
      // Keep answer facts, but eliminate repetitive links such as "See our Shipping Policy".
      section.details.forEach((details) => {
        details.querySelectorAll('.faq-canonical__answer a[href*="/policies/"]').forEach((link) => {
          const paragraph = link.closest('p');
          const previous = link.previousSibling;
          if (previous?.nodeType === Node.TEXT_NODE) {
            previous.textContent = previous.textContent.replace(/(?:[;,.]\s*)?(?:see|read|view)\s+(?:our|the)\s*$/i, '').replace(/(?:[;,.]\s*)?ətraflı məlumat(?: üçün)?\s*:?\s*$/i, '').replace(/\s+$/, '');
          }
          link.remove();
          if (paragraph && !paragraph.textContent.replace(/[\s.,;:·]/g, '').length) paragraph.remove();
        });
      });
      const applicable = policiesBySection[index] || [];
      if (applicable.length) {
        const group = document.createElement('div');
        group.className = 'faq-canonical__policy-links';
        group.setAttribute('aria-label', isFr ? 'Politiques associées' : isAz ? 'Əlaqəli siyasətlər' : 'Related policies');
        applicable.forEach((handle) => {
          const labels = policyCatalog[handle];
          if (!labels) return;
          const link = document.createElement('a');
          link.className = 'faq-canonical__policy-link';
          link.href = marketPrefix + '/policies/' + handle;
          link.textContent = isFr ? frenchPolicyLabels[handle] : isAz ? labels[1] : labels[0];
          const arrow = document.createElement('span');
          arrow.setAttribute('aria-hidden', 'true');
          arrow.textContent = '→';
          link.appendChild(arrow);
          group.appendChild(link);
        });
        section.element.appendChild(group);
      }
      section.searchText = section.element.textContent.toLowerCase();
    });

    const byId = Object.fromEntries(sections.map(section => [section.id, section]));
    const navOrder = sections.map(section => section.id);
    const navItems = new Map();

    navOrder.forEach((id) => {
      const section = byId[id];
      if (!section) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'faq-canonical__nav-item';
      button.dataset.faqCategory = id;
      button.innerHTML = '<span class="faq-canonical__nav-item-icon" aria-hidden="true">' + iconFor(section.title) + '</span><strong></strong><span class="faq-canonical__nav-arrow" aria-hidden="true">›</span>';
      button.querySelector('strong').textContent = displayTitle(section.id, section.title);
      nav.appendChild(button);
      navItems.set(id, button);
    });



    const highlightNavigation = (id) => {
      activeId = id;
      navItems.forEach((item, key) => {
        item.classList.toggle('is-active', key === id);
        if (key === id) item.setAttribute('aria-current', 'location');
        else item.removeAttribute('aria-current');
      });
    };
    let searchActive = false;
    let scrollPending = false;
    const updateNavigationFromScroll = () => {
      scrollPending = false;
      if (searchActive) return;
      const threshold = Math.max(128, Math.min(190, window.innerHeight * 0.27));
      let candidate = sections[0];
      sections.forEach((section) => {
        if (section.element.isConnected && section.element.getBoundingClientRect().top <= threshold) candidate = section;
      });
      if (candidate && candidate.id !== activeId) highlightNavigation(candidate.id);
    };
    const scheduleScrollUpdate = () => {
      if (scrollPending) return;
      scrollPending = true;
      window.requestAnimationFrame(updateNavigationFromScroll);
    };
    window.addEventListener('scroll', scheduleScrollUpdate, { passive: true });
    window.addEventListener('resize', scheduleScrollUpdate);

    const resetVisibility = () => {
      sections.forEach((section) => {
        section.details.forEach((details) => details.hidden = false);
        if (section.note) section.note.hidden = false;
      });
    };

    let activeId = byId['before-purchase'] ? 'before-purchase' : sections[0].id;

    const renderAll = () => {
      searchActive = false;
      resetVisibility();
      target.replaceChildren();
      sections.forEach((section) => {
        target.appendChild(section.element);
      });
      panel.classList.remove('faq-canonical__panel--single');
      panelTitle.textContent = isAz ? 'Tez-tez verilən suallar' : 'FAQs';
      count.textContent = '';
      highlightNavigation(activeId);
      [...target.querySelectorAll('details')].forEach((details) => details.open = true);
      scheduleScrollUpdate();
    };

    const setActive = (id) => {
      const section = byId[id];
      if (!section) return;
      activeId = id;
      resetVisibility();
      target.replaceChildren();
      target.appendChild(section.element);
      if (id === 'before-purchase' && byId['product-quality']) target.appendChild(byId['product-quality'].element);
      panel.classList.add('faq-canonical__panel--single');
      panelTitle.textContent = displayTitle(section.id, section.title);
      const total = section.details.length + (id === 'before-purchase' && byId['product-quality'] ? byId['product-quality'].details.length : 0);
      count.textContent = total ? total + (isAz ? ' sual' : (total === 1 ? ' question' : ' questions')) : (isAz ? 'Məlumat' : 'Info');
      navItems.forEach((button, key) => button.classList.toggle('is-active', key === id));
      [...target.querySelectorAll('details')].forEach((details) => details.open = true);
    };

    nav.addEventListener('click', (event) => {
      const button = event.target.closest('[data-faq-category]');
      if (!button) return;
      const id = button.dataset.faqCategory;
      const section = byId[id];
      if (!section) return;
      searchActive = false;
      highlightNavigation(id);
      section.element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    target.addEventListener('click', (event) => {
      const summary = event.target.closest('summary');
      if (!summary || !target.contains(summary)) return;
      event.preventDefault();
      const details = summary.closest('details');
      if (details) details.open = true;
    });

    const runSearch = (term) => {
      const query = term.trim().toLowerCase();
      if (!query) {
        renderAll();
        return;
      }
      searchActive = true;
      resetVisibility();
      target.replaceChildren();
      let matches = 0;

      sections.forEach((section) => {
        let sectionMatch = false;
        section.details.forEach((details) => {
          const match = details.textContent.toLowerCase().includes(query);
          details.hidden = !match;
          if (match) {
            details.open = true;
            matches += 1;
            sectionMatch = true;
          }
        });
        if (section.note) {
          const match = section.note.textContent.toLowerCase().includes(query);
          section.note.hidden = !match;
          if (match) {
            matches += 1;
            sectionMatch = true;
          }
        }
        if (sectionMatch || section.title.toLowerCase().includes(query)) {
          target.appendChild(section.element);
        }
      });

      panel.classList.remove('faq-canonical__panel--single');
      panelTitle.textContent = isAz ? 'Axtarış nəticələri' : 'Search Results';
      count.textContent = matches + (isAz ? ' nəticə' : (matches === 1 ? ' result' : ' results'));
      navItems.forEach((button) => button.classList.remove('is-active'));

      if (!target.children.length) {
        const empty = document.createElement('div');
        empty.className = 'faq-canonical__note';
        empty.textContent = isAz ? 'Axtarışınıza uyğun cavab tapılmadı. Daha ümumi sözlə axtarın və ya dəstək komandamızla əlaqə saxlayın.' : 'No FAQ answers matched your search. Try a broader term or contact our support team.';
        target.appendChild(empty);
      }
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    searchForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      runSearch(searchInput?.value || '');
    });

    root.querySelectorAll('[data-faq-search-term]').forEach((button) => {
      button.addEventListener('click', () => {
        const term = button.dataset.faqSearchTerm || '';
        if (searchInput) searchInput.value = term;
        runSearch(term);
      });
    });

    renderAll();
    root.classList.add('faq-canonical--enhanced');
  });
})();